import { Logo } from "../Logo.tsx";
import styles from "./Splash.module.css";

/** Экран на время восстановления сессии при старте, чтобы не мигал экран входа. */
export function Splash() {
  return (
    <div className={styles.splash} role="status" aria-label="Загрузка">
      <Logo />
    </div>
  );
}
